var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.644531,
    y: 0.416016,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2188 15.6161C35.893 14.3892 34.9329 13.4228 33.7139 13.0949C31.5043 12.499 22.6442 12.499 22.6442 12.499C22.6442 12.499 13.7842 12.499 11.5746 13.0949C10.3555 13.4229 9.39545 14.3892 9.06959 15.6161C8.47754 17.8401 8.47754 22.4801 8.47754 22.4801C8.47754 22.4801 8.47754 27.1201 9.06959 29.344C9.39545 30.571 10.3555 31.497 11.5746 31.825C13.7842 32.4209 22.6442 32.4209 22.6442 32.4209C22.6442 32.4209 31.5042 32.4209 33.7139 31.825C34.9329 31.497 35.893 30.571 36.2188 29.344C36.8109 27.1201 36.8109 22.4801 36.8109 22.4801C36.8109 22.4801 36.8109 17.8401 36.2188 15.6161ZM19.7465 26.6929V18.2673L27.1517 22.4802L19.7465 26.6929Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a0bcc29f3a400b6ec56bbf22610bdc0f.svg";
export { ForwardRef as ReactComponent };